import { normalisePlainText } from "./normalise-plain-text.mjs"

function normaliseAmendsContent(content) {
    return normalisePlainText(`${content ?? ""}`.replace(/<[^>]*>/g, ""))
}

export function hasAmendsContent(content) {
    return normaliseAmendsContent(content).length > 0
}

export function normaliseAmendsContentForSave(content) {
    return hasAmendsContent(content) ? content : null
}
